/**
 * Newsletter Subscription Service
 *
 * Handles newsletter subscription via CRM API.
 * Failures are logged but do not block the booking flow.
 */

import { crmClient } from './crmClient';
import {
  NewsletterSubscriptionSchema,
  type NewsletterSubscriptionPayload,
  type NewsletterSubscriptionResult,
} from '@/types/schemas/crm/newsletter';

/**
 * Subscribe email to newsletter
 *
 * @param payload - Newsletter subscription data
 * @returns Result with success flag and optional error
 */
export async function subscribeToNewsletter(
  payload: NewsletterSubscriptionPayload
): Promise<NewsletterSubscriptionResult> {
  try {
    // Validate payload before sending
    const validatedPayload = NewsletterSubscriptionSchema.parse(payload);

    await crmClient.post({
      endpoint: '/add-recipient',
      data: validatedPayload,
      requestSchema: NewsletterSubscriptionSchema,
      // No response schema - we only check HTTP status
    });

    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    console.error('[Newsletter] Subscription failed:', errorMessage);
    return { success: false, error: errorMessage };
  }
}
